import React from 'react';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import GoogleAnalytics from '../../../util/Ga.js';
// ES6 className-style
class DayInLife extends PreLoginSessionCheck {

  render() {
	 
  	return(
		<section className="product-main">
			<div className="container"> 
				<div className="">
					<div className="row">
						<h2>A Day in Our Life</h2>
						<div className="col-md-4">
							<div className="our-life">
								<div className="our-img"><img src="../img/day1.jpg" alt="Germination of an idea" /></div>
								<p>Germination of an idea</p>
							</div>	 	
						</div>
						<div className="col-md-4">
							<div className="our-life">
								<div className="our-img"><img src="../img/day2.jpg" alt="Discussing the visuals and animations" /></div>
								<p>Discussing the visuals and animations</p>
							</div>	 
						</div>
						<div className="col-md-4">
							<div className="our-life">
								<div className="our-img"><img src="../img/day3.jpg" alt="Designing interactive activities" /></div>
								<p>Designing interactive activities</p>
							</div>
						</div>
						<div className="col-md-12">
							<div className="our-life">
								<div className="our-img"><img src="../img/day4.jpg" alt="Showcasing to users for critical feedback" /></div>
								<p>Showcasing to users for critical feedback </p>
							</div>
						</div>
					</div>
				</div> 
				</div>
			</section>
  		);
  	}
}

export default DayInLife; 


// WEBPACK FOOTER //
// ./src/prelogin/src/components/DayInLife.js